import { render, staticRenderFns } from "./SelectPopover.vue?vue&type=template&id=88c7b49e"
import script from "./SelectPopover.vue?vue&type=script&lang=js"
export * from "./SelectPopover.vue?vue&type=script&lang=js"
import style0 from "./SelectPopover.vue?vue&type=style&index=0&id=88c7b49e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports